module.exports = __webpack_public_path__ + "static/2-15d0cfab430d5a14f50fd4c34aefa28c.jpeg";